import React from 'react';
import { useField } from 'formik';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';
import styles from './styles.scss';
import SelectInput from '../../../../../../modules/react/components/stateful/SelectInput';
import Translation from '../../../../../components/stateless/Translation';

const CheckoutFormDropdown = ({
  errorClassName,
  invalidClassName,
  validate,
  label,
  className,
  required,
  requiredStar,
  name,
  ...rest
}) => {
  const [field, meta] = useField({ name, validate });
  const error = meta.touched && !isEmpty(meta.error);

  const fieldClasses = classNames(
    styles.checkoutFormDropdown,
    error && styles.error,
    error && invalidClassName,
    (required || requiredStar) && styles.required,
    className,
  );

  return (
    <div className={fieldClasses}>
      <div className={styles.label}>
        <div className={styles.text}>
          <Translation {...label} />
        </div>
      </div>
      <div>
        <SelectInput
          {...field}
          {...rest}
          required={required}
        />
      </div>
      {error && (
        <div className={classNames(styles.message, errorClassName)} role="alert">
          <Translation
            defaultMessage="Field is invalid"
            id={meta.error}
          />
        </div>
      )}
    </div>
  );
};

export default CheckoutFormDropdown;
